module.exports = __webpack_public_path__ + "img/LTS_SAIGA_1.2c4e13af.gif";